<!-- Dialog de Variantes e Modificadores (reaproveitado do PDV) -->
<p-dialog
  [(visible)]="visible"
  [showHeader]="false"
  [modal]="true"
  [closable]="false"
  [draggable]="false"
  styleClass="dialog-wave-redesign"
  [style]="{ width: '500px', height: 'auto' }"
  [contentStyle]="{ 'max-height': '70vh', 'overflow-y': 'auto' }"
  (onHide)="onHide()">

  <!-- HEADER CUSTOMIZADO COM WAVE -->
  <div class="dialog-wave-header">
    <div class="dialog-wave-header-content">
      <div class="dialog-wave-icon-container">
        <i class="pi pi-list" aria-hidden="true"></i>
      </div>
      <div class="dialog-wave-header-text">
        <h2>{{ 'vendas.variantes.dialog_titulo' | translate }}</h2>
        <p>{{ produtoAtual?.nome }}</p>
      </div>
    </div>
    <div class="dialog-wave-decorative-circle circle-1" aria-hidden="true"></div>
    <div class="dialog-wave-decorative-circle circle-2" aria-hidden="true"></div>
    <svg class="dialog-wave-svg" viewBox="0 0 1200 40" preserveAspectRatio="none" aria-hidden="true">
      <path d="M0,20 C150,40 350,0 500,20 C650,40 850,0 1000,20 C1100,32 1150,20 1200,20 L1200,40 L0,40 Z" fill="white"/>
    </svg>
  </div>

  <!-- CORPO DO DIALOG -->
  <div class="dialog-wave-body variante-modificador-body">

    <!-- Loading state -->
    <div *ngIf="carregando" class="vm-loading">
      <p-progressSpinner [style]="{ width: '40px', height: '40px' }" strokeWidth="4"></p-progressSpinner>
      <span class="vm-loading-text">{{ 'vendas.variantes.carregando_opcoes' | translate }}</span>
    </div>

    <!-- Conteudo quando carregado -->
    <ng-container *ngIf="!carregando">

      <!-- Produto sticky (imagem + nome + preco base) -->
      <div class="vm-produto-sticky" *ngIf="produtoAtual">
        <img
          *ngIf="produtoAtual.imagem"
          [src]="env.imgHost + '/' + idEmpresa + '/item/' + produtoAtual.imagem"
          class="vm-produto-img"
          [alt]="produtoAtual.nome"
          (error)="$any($event.target).style.display='none'">
        <div *ngIf="!produtoAtual.imagem" class="vm-produto-img-placeholder">
          <i class="pi pi-box"></i>
        </div>
        <div class="vm-produto-info">
          <span class="vm-produto-nome">{{ produtoAtual.nome }}</span>
          <span class="vm-produto-preco-base">
            {{ 'vendas.variantes.preco_base' | translate }}:
            <span *ngIf="moedaPadrao === 'PYG'">{{ produtoAtual.precoDeVenda | guaraniFormat }}</span>
            <span *ngIf="moedaPadrao !== 'PYG'">{{ produtoAtual.precoDeVenda | moedaSimbolo: moedaPadrao:digitsMoeda:localeMoeda }}</span>
          </span>
        </div>
      </div>

      <!-- Secao de Variantes -->
      <div *ngIf="variantesDisponiveis.length > 0" class="vm-secao vm-secao-variante" [class.vm-secao-pendente]="!varianteSelecionada">
        <h3 class="vm-secao-titulo">
          <i class="pi pi-th-large vm-secao-icone"></i>
          <span class="vm-secao-titulo-texto">{{ 'vendas.variantes.selecionar_variante' | translate }}</span>
          <span class="vm-badge-obrigatorio" *ngIf="!varianteSelecionada">
            {{ 'vendas.variantes.obrigatorio' | translate }}
          </span>
          <span class="vm-badge-selecionado" *ngIf="varianteSelecionada">
            <i class="pi pi-check"></i> {{ 'vendas.variantes.selecionado' | translate }}
          </span>
        </h3>
        <p class="vm-secao-explicacao">{{ 'vendas.variantes.explicacao_variante' | translate }}</p>
        <div class="vm-opcoes-lista">
          <div
            *ngFor="let variante of variantesDisponiveis"
            class="vm-opcao"
            [class.vm-opcao-selecionada]="varianteSelecionada?.id === variante.id"
            (click)="selecionarVariante(variante)">
            <div class="vm-opcao-radio">
              <i [class]="varianteSelecionada?.id === variante.id ? 'pi pi-circle-fill' : 'pi pi-circle'"></i>
            </div>
            <div class="vm-opcao-info">
              <span class="vm-opcao-descricao">{{ variante.descricao }}</span>
            </div>
            <div class="vm-opcao-preco">
              <span *ngIf="moedaPadrao === 'PYG'">{{ variante.precoDeVenda | guaraniFormat }}</span>
              <span *ngIf="moedaPadrao !== 'PYG'">{{ variante.precoDeVenda | moedaSimbolo: moedaPadrao:digitsMoeda:localeMoeda }}</span>
            </div>
          </div>
        </div>
      </div>

      <!-- Separador entre variantes e modificadores -->
      <div *ngIf="variantesDisponiveis.length > 0 && gruposModificadores.length > 0" class="vm-separador"></div>

      <!-- Secao de Modificadores (por grupo) -->
      <div *ngFor="let grupo of gruposModificadores" class="vm-secao vm-secao-modificador" [class.vm-secao-pendente]="isGrupoComMinimoPendente(grupo)">
        <h3 class="vm-secao-titulo">
          <i class="pi pi-plus-circle vm-secao-icone"></i>
          <span class="vm-secao-titulo-texto" [pTooltip]="grupo.descricao" tooltipPosition="top">{{ grupo.descricao }}</span>
          <span class="vm-badge-contador" *ngIf="grupo.maximoDeModificadores > 0"
            [class.vm-badge-contador-cheio]="getTotalSelecoesGrupo(grupo.id!) >= grupo.maximoDeModificadores"
            [class.vm-badge-contador-pendente]="isGrupoComMinimoPendente(grupo)">
            {{ 'vendas.variantes.selecionados_contador' | translate:{ atual: getTotalSelecoesGrupo(grupo.id!), max: grupo.maximoDeModificadores } }}
          </span>
          <span class="vm-badge-obrigatorio" *ngIf="grupo.minimoDeModificadores > 0 && isGrupoComMinimoPendente(grupo)">
            {{ 'vendas.variantes.obrigatorio' | translate }}
          </span>
        </h3>
        <p class="vm-secao-explicacao">{{ 'vendas.variantes.explicacao_modificador' | translate }}</p>
        <div *ngIf="isGrupoComMinimoPendente(grupo)" class="vm-aviso-minimo">
          <i class="pi pi-exclamation-triangle"></i>
          {{ 'vendas.variantes.selecione_pelo_menos' | translate:{ min: grupo.minimoDeModificadores } }}
        </div>
        <div class="vm-opcoes-lista">
          <!-- Modo RADIO: maximo = 1 -->
          <ng-container *ngIf="grupo.maximoDeModificadores === 1">
            <div
              *ngFor="let mod of grupo.modificadores"
              class="vm-opcao"
              [class.vm-opcao-selecionada]="isModificadorSelecionado(grupo.id!, mod.id!)"
              (click)="toggleModificador(grupo, mod)">
              <div class="vm-opcao-radio">
                <i [class]="isModificadorSelecionado(grupo.id!, mod.id!) ? 'pi pi-circle-fill' : 'pi pi-circle'"></i>
              </div>
              <div class="vm-opcao-info">
                <span class="vm-opcao-descricao">{{ mod.descricao }}</span>
              </div>
              <div class="vm-opcao-preco">
                <span *ngIf="moedaPadrao === 'PYG'">+{{ mod.precoDeVenda | guaraniFormat }}</span>
                <span *ngIf="moedaPadrao !== 'PYG'">+{{ mod.precoDeVenda | moedaSimbolo: moedaPadrao:digitsMoeda:localeMoeda }}</span>
              </div>
            </div>
          </ng-container>

          <!-- Modo QUANTIDADE: maximo > 1 -->
          <ng-container *ngIf="grupo.maximoDeModificadores !== 1">
            <div
              *ngFor="let mod of grupo.modificadores"
              class="vm-opcao"
              [class.vm-opcao-selecionada]="isModificadorSelecionado(grupo.id!, mod.id!)">
              <div class="vm-opcao-info vm-opcao-info-qty">
                <span class="vm-opcao-descricao">{{ mod.descricao }}</span>
              </div>
              <div class="vm-qty-controles">
                <button
                  pButton
                  type="button"
                  icon="pi pi-minus"
                  class="p-button-rounded p-button-text p-button-sm vm-qty-btn"
                  [disabled]="getQuantidadeModificador(grupo.id!, mod.id!) <= 0"
                  (click)="decrementarModificador(grupo.id!, mod.id!); $event.stopPropagation()">
                </button>
                <span class="vm-qty-valor" [class.vm-qty-valor-ativo]="getQuantidadeModificador(grupo.id!, mod.id!) > 0">
                  {{ getQuantidadeModificador(grupo.id!, mod.id!) }}
                </span>
                <button
                  pButton
                  type="button"
                  icon="pi pi-plus"
                  class="p-button-rounded p-button-text p-button-sm vm-qty-btn"
                  [disabled]="isGrupoMaxAtingido(grupo.id!, grupo.maximoDeModificadores)"
                  (click)="incrementarModificador(grupo, mod); $event.stopPropagation()">
                </button>
              </div>
              <div class="vm-opcao-preco">
                <ng-container *ngIf="getQuantidadeModificador(grupo.id!, mod.id!) > 0; else precoUnitario">
                  <span *ngIf="moedaPadrao === 'PYG'">+{{ mod.precoDeVenda * getQuantidadeModificador(grupo.id!, mod.id!) | guaraniFormat }}</span>
                  <span *ngIf="moedaPadrao !== 'PYG'">+{{ mod.precoDeVenda * getQuantidadeModificador(grupo.id!, mod.id!) | moedaSimbolo: moedaPadrao:digitsMoeda:localeMoeda }}</span>
                </ng-container>
                <ng-template #precoUnitario>
                  <span class="vm-preco-unitario-hint">
                    <span *ngIf="moedaPadrao === 'PYG'">+{{ mod.precoDeVenda | guaraniFormat }}</span>
                    <span *ngIf="moedaPadrao !== 'PYG'">+{{ mod.precoDeVenda | moedaSimbolo: moedaPadrao:digitsMoeda:localeMoeda }}</span>
                  </span>
                </ng-template>
              </div>
            </div>
          </ng-container>
        </div>
      </div>

      <!-- Observacao do item (opcional) -->
      <div class="vm-secao vm-secao-modificador vm-secao-observacao">
        <h3 class="vm-secao-titulo">
          <i class="pi pi-comment vm-secao-icone"></i>
          <span class="vm-secao-titulo-texto">{{ 'vendas.variantes.observacao' | translate }}</span>
        </h3>
        <textarea
          pInputTextarea
          rows="2"
          class="w-full vm-observacao-input"
          [(ngModel)]="observacao"
          [placeholder]="'vendas.variantes.observacao_ph' | translate">
        </textarea>
      </div>

      <!-- Preco Final sticky com breakdown -->
      <div class="vm-preco-final">
        <div class="vm-preco-breakdown" *ngIf="breakdownPreco.length > 1">
          <div *ngFor="let item of breakdownPreco" class="vm-breakdown-item">
            <span class="vm-breakdown-desc">
              <span *ngIf="item.tipo === 'modificador'">+ </span>{{ item.descricao }}<span *ngIf="item.quantidade && item.quantidade > 1"> (x{{ item.quantidade }})</span>
            </span>
            <span class="vm-breakdown-valor">
              <span *ngIf="item.tipo === 'modificador'">+</span>
              <span *ngIf="moedaPadrao === 'PYG'">{{ item.valor | guaraniFormat }}</span>
              <span *ngIf="moedaPadrao !== 'PYG'">{{ item.valor | moedaSimbolo: moedaPadrao:digitsMoeda:localeMoeda }}</span>
            </span>
          </div>
          <div class="vm-breakdown-separador"></div>
        </div>
        <div class="vm-preco-final-row">
          <span class="vm-preco-final-label">{{ 'vendas.variantes.preco_final' | translate }}:</span>
          <span class="vm-preco-final-valor" *ngIf="precoCalculado > 0">
            <span *ngIf="moedaPadrao === 'PYG'">{{ precoCalculado | guaraniFormat }}</span>
            <span *ngIf="moedaPadrao !== 'PYG'">{{ precoCalculado | moedaSimbolo: moedaPadrao:digitsMoeda:localeMoeda }}</span>
          </span>
          <span class="vm-preco-final-placeholder" *ngIf="precoCalculado === 0">
            {{ 'vendas.variantes.selecione_opcao' | translate }}
          </span>
        </div>
      </div>

    </ng-container>
  </div>

  <ng-template pTemplate="footer">
    <div class="vm-footer-wrapper">
      <div class="vm-validacao-msg" *ngIf="!podeConfirmar && !carregando && (variantesDisponiveis.length > 0 || gruposModificadores.length > 0)">
        <i class="pi pi-exclamation-triangle"></i>
        <span>{{ mensagemValidacao }}</span>
      </div>
      <div class="vm-footer-buttons">
        <button pButton class="p-button-text p-button-secondary" (click)="cancelarSelecao()">
          {{ 'vendas.buttons.cancelar' | translate }}
        </button>
        <button pButton icon="pi pi-check"
          [disabled]="!podeConfirmar"
          (click)="confirmarSelecao()">
          {{ 'vendas.variantes.confirmar_enter' | translate }}
        </button>
      </div>
    </div>
  </ng-template>
</p-dialog>
